export default __webpack_public_path__ + "static/media/BlackKey.847443b5.svg";